export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_API_URL;
export const LANDING_BACKEND_URL = `${BACKEND_BASE_URL}/landing`;
export const REQUESTS_BACKEND_URL = `${BACKEND_BASE_URL}/requests`;
export const COMPANY_BACKEND_URL = `${BACKEND_BASE_URL}/company`;
export const ACCOUNTS_BACKEND_URL = `${BACKEND_BASE_URL}/accounts`;

export const DASHBOARD_BASE_URL = process.env.REACT_APP_DASHBOARD_BASE_API_URL;


// WEBPACK FOOTER //
// ./src/Constants/Global/apiConstants.js